import { useDispatch } from 'react-redux'

import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useIsDashboardOpen } from 'builder/hooks/useIsDashboardOpen'
import { actions as uiActions, selectors as uiSelectors } from 'builder/modules/ui'

const MODAL_SHOWN_STORAGE_KEY = 'rd-auto-apply-dual-modal'

export const useAutoApplyResumeDistributionModal = () => {
  const dispatch = useDispatch()
  const isDashboard = useIsDashboardOpen()
  const isOpen = useTypedSelector(uiSelectors.isAutoApplyResumeDistributionModalOpen)

  const closeModal = () => {
    localStorage.setItem(MODAL_SHOWN_STORAGE_KEY, 'true')
    dispatch(uiActions.toggleAutoApplyResumeDistributionModal(false))
  }

  return { isOpen: isOpen && !!isDashboard, closeModal }
}
